"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const effects_1 = require("redux-saga/effects");
const config_1 = require("../../../web/firebase/config");
const User_1 = __importDefault(require("../../networking/apis/User"));
const actions_1 = __importStar(require("./actions"));
const AsyncStorage_1 = __importDefault(require("../../utils/AsyncStorage"));
const constants_1 = __importDefault(require("../../constants/constants"));
// import AsyncStorage from "../../utils/AsyncStorage";
// import constants from "../../constants/constants";
function loginWithCustomToken(customToken) {
    return new Promise((resolve, reject) => {
        config_1.firebase
            .auth()
            .signInWithCustomToken(customToken)
            .then((res) => {
            resolve(res);
        })
            .catch(async (err) => {
            reject(err);
            await AsyncStorage_1.default.remove(constants_1.default.FIREBASE_TOKEN);
            (0, effects_1.put)(loginFirebase());
        });
    });
}
function* loginFirebase() {
    try {
        const firebaseToken = yield AsyncStorage_1.default.get(constants_1.default.FIREBASE_TOKEN);
        if (!firebaseToken) {
            const response = yield User_1.default?.getTokenFirebaseAuthToken();
            if (response?.data?.data?.custom_token) {
                const res = yield loginWithCustomToken(response.data.data.custom_token);
                AsyncStorage_1.default.set(constants_1.default.FIREBASE_TOKEN, response.data.data.custom_token);
                yield (0, effects_1.put)(actions_1.default.loginFirebaseSuccessAction(res?.user));
            }
        }
        else {
            const res = yield loginWithCustomToken(firebaseToken);
            yield (0, effects_1.put)(actions_1.default.loginFirebaseSuccessAction(res?.user));
        }
    }
    catch (error) {
        yield (0, effects_1.put)(actions_1.default.loginFirebaseErrorAction());
    }
}
function* logoutFirebase(_action) {
    try {
        yield config_1.firebase.auth().signOut();
        yield (0, effects_1.put)(actions_1.default.loginFirebaseSuccessAction(null));
        yield AsyncStorage_1.default.remove(constants_1.default.FIREBASE_TOKEN);
    }
    catch (error) { }
}
function* refreshFirebaseToken() {
    try {
        const response = yield User_1.default?.getTokenFirebaseAuthToken();
        if (response?.data?.data?.custom_token) {
            const res = yield loginWithCustomToken(response.data.data.custom_token);
            AsyncStorage_1.default.set(constants_1.default.FIREBASE_TOKEN, response.data.data.custom_token);
            yield (0, effects_1.put)(actions_1.default.loginFirebaseSuccessAction(res?.user));
        }
    }
    catch (error) { }
}
function* loginFirebaseSaga() {
    yield (0, effects_1.all)([
        (0, effects_1.takeLatest)(actions_1.LOGIN_FIREBASE_START, loginFirebase),
        (0, effects_1.takeLatest)(actions_1.LOGOUT_FIREBASE_START, logoutFirebase),
        (0, effects_1.takeLatest)(actions_1.REFRESH_FIREBASE_AUTH, refreshFirebaseToken),
    ]);
}
exports.default = loginFirebaseSaga;
